var map = {
	"./01.svg": 83367,
	"./02.svg": 7767,
	"./03.svg": 68000,
	"./04.svg": 68303,
	"./05.svg": 99486,
	"./06.svg": 96556,
	"./08.svg": 34994,
	"./09.svg": 29668
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 15243;